import {
  ENABLE_TEST_UTILITIES,
  ENABLE_V2_COMPONENTS,
  DISABLED_V2_COMPONENTS,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').TestingAndDiagnosis} TestingAndDiagnosis
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @type {TestingAndDiagnosis}
 */
const INITIAL_STATE = {
  testingAndDiagnosisEnabled: false,
  v2: false,
}

/**
 * @param {TestingAndDiagnosis} state
 * @param {PltrAction} action
 * @return {TestingAndDiagnosis}
 */
const testingAndDiagnosis = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ENABLE_TEST_UTILITIES: {
      return {
        ...state,
        testingAndDiagnosisEnabled: true,
      }
    }
    case ENABLE_V2_COMPONENTS: {
      return {
        ...state,
        v2: true,
      }
    }
    case DISABLED_V2_COMPONENTS: {
      return {
        ...state,
        v2: false,
      }
    }
    default: {
      return state
    }
  }
}

export default testingAndDiagnosis
